/* ============================================================
   pieszo — logika buy boxa (sekcja pieszo-hero)
   Slider galerii, wybór wariantu, ilość, upsell, dodawanie do koszyka
   ============================================================ */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var f = format || '{{amount_with_comma_separator}} zł';
    return f
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  // "Różowy" -> "rozow" (rdzeń bez końcówki, bez polskich znaków)
  function colorStem(value) {
    var map = { 'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z' };
    var v = String(value || '').toLowerCase().replace(/[ąćęłńóśżź]/g, function (c) { return map[c]; });
    return v.replace(/[aeiouy]+$/, '');
  }

  function initHero(root) {
    var dataEl = root.querySelector('[data-pz-product]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount_with_comma_separator}} zł';

    var state = { options: [] };
    var first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    state.options = first.options.slice();

    var track = root.querySelector('[data-pz-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pz-thumb]'));
    var badge = root.querySelector('[data-pz-badge]');
    var priceEl = root.querySelector('[data-pz-price]');
    var compareEl = root.querySelector('[data-pz-compare]');
    var savePill = root.querySelector('[data-pz-save]');
    var idInput = root.querySelector('[data-pz-variant-id]');
    var qtyInput = root.querySelector('[data-pz-qty]');
    var atcBtn = root.querySelector('[data-pz-atc]');
    var atcLabel = atcBtn ? atcBtn.querySelector('[data-pz-atc-label]') : null;
    var errEl = root.querySelector('[data-pz-error]');
    var currentIndex = 0;

    /* ---------- galeria: przewijany slider ---------- */
    /* ---------- strzałki nawigacji miniatur ---------- */
    var thumbsStrip = root.querySelector('[data-pz-thumbs]');
    var arrowPrev = root.querySelector('[data-pz-thumbs-prev]');
    var arrowNext = root.querySelector('[data-pz-thumbs-next]');

    function updateArrows() {
      if (!thumbsStrip || !arrowPrev || !arrowNext) return;
      var maxScroll = thumbsStrip.scrollWidth - thumbsStrip.clientWidth;
      if (maxScroll <= 4) { arrowPrev.hidden = true; arrowNext.hidden = true; return; }
      arrowPrev.hidden = thumbsStrip.scrollLeft <= 4;
      arrowNext.hidden = thumbsStrip.scrollLeft >= maxScroll - 4;
    }

    function stepThumbs(dir) {
      if (!thumbsStrip) return;
      var first = thumbsStrip.querySelector('.pz-thumb');
      var step = first ? (first.offsetWidth + 10) * 2 : 180; // ~2 miniatury
      thumbsStrip.scrollBy({ left: dir * step, behavior: 'smooth' });
      setTimeout(updateArrows, 400);
    }

    if (arrowPrev) arrowPrev.addEventListener('click', function () { stepThumbs(-1); });
    if (arrowNext) arrowNext.addEventListener('click', function () { stepThumbs(1); });
    if (thumbsStrip) {
      var arrowTimer;
      thumbsStrip.addEventListener('scroll', function () {
        clearTimeout(arrowTimer);
        arrowTimer = setTimeout(updateArrows, 60);
      });
      window.addEventListener('resize', updateArrows);
      updateArrows();
      setTimeout(updateArrows, 500); // po doładowaniu miniatur
    }

    // przewiń pasek miniatur tak, by aktywna była widoczna (nie rusza scrolla strony)
    function revealThumb(thumb) {
      if (!thumb) return;
      var wrap = thumb.parentElement;
      if (!wrap || wrap.scrollWidth <= wrap.clientWidth) return;
      var left = thumb.offsetLeft;
      var right = left + thumb.offsetWidth;
      if (left < wrap.scrollLeft || right > wrap.scrollLeft + wrap.clientWidth) {
        wrap.scrollTo({
          left: Math.max(0, left - (wrap.clientWidth - thumb.offsetWidth) / 2),
          behavior: 'smooth'
        });
        setTimeout(updateArrows, 400);
      }
    }

    function syncGallery(index) {
      currentIndex = index;
      thumbs.forEach(function (t) {
        var active = parseInt(t.getAttribute('data-index'), 10) === index;
        t.classList.toggle('is-active', active);
        if (active) revealThumb(t);
      });
      // plakietka promocyjna tylko na pierwszym zdjęciu
      if (badge) badge.classList.toggle('pz-badge--hidden', index !== 0);
    }

    function goTo(index) {
      if (!track || index < 0 || index >= slides.length) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      syncGallery(index);
    }

    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var index = Math.round(track.scrollLeft / track.clientWidth);
          if (index !== currentIndex) syncGallery(index);
        }, 80);
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-index'), 10));
      });
    });

    // indeks zdjęcia pasującego do wariantu: najpierw zdjęcie wariantu, potem nazwa pliku z kolorem
    function imageIndexForVariant(variant) {
      if (variant && variant.featured_image && variant.featured_image.src) {
        var name = variant.featured_image.src.split('/').pop().split('?')[0].toLowerCase();
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-name') === name) return i;
        }
      }
      for (var o = 0; o < state.options.length; o++) {
        var stem = colorStem(state.options[o]);
        if (stem.length < 3) continue;
        for (var j = 0; j < slides.length; j++) {
          if (slides[j].getAttribute('data-name').indexOf(stem) > -1) return j;
        }
      }
      return -1;
    }

    /* ---------- warianty ---------- */
    function currentVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === state.options[i]; });
      });
    }

    function render(scrollToImage) {
      var v = currentVariant();
      root.querySelectorAll('[data-pz-opt]').forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-opt-index'), 10);
        btn.classList.toggle('is-active', state.options[idx] === btn.getAttribute('data-opt-value'));
      });
      root.querySelectorAll('[data-pz-opt-value]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-pz-opt-value'), 10);
        el.textContent = state.options[idx] || '';
      });
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.style.display = '';
            compareEl.textContent = formatMoney(v.compare_at_price, moneyFormat);
            if (savePill) {
              savePill.style.display = '';
              savePill.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
            }
          } else {
            compareEl.style.display = 'none';
            if (savePill) savePill.style.display = 'none';
          }
        }
        if (scrollToImage) {
          var target = imageIndexForVariant(v);
          if (target > -1 && target !== currentIndex) goTo(target);
        }
        if (atcBtn) {
          atcBtn.disabled = !v.available;
          if (atcLabel) atcLabel.textContent = v.available ? atcBtn.getAttribute('data-label-add') : atcBtn.getAttribute('data-label-soldout');
        }
      }
    }

    root.querySelectorAll('[data-pz-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.options[parseInt(btn.getAttribute('data-opt-index'), 10)] = btn.getAttribute('data-opt-value');
        render(true);
      });
    });

    /* ---------- upsell: zmiana wariantu podmienia zdjęcie ---------- */
    var upsellSelect = root.querySelector('select[data-pz-upsell-variant]');
    var upsellImg = root.querySelector('[data-pz-upsell-img]');
    if (upsellSelect && upsellImg) {
      var syncUpsellImg = function () {
        var opt = upsellSelect.options[upsellSelect.selectedIndex];
        var src = opt ? opt.getAttribute('data-img') : null;
        if (src && upsellImg.getAttribute('src') !== src) upsellImg.src = src;
      };
      upsellSelect.addEventListener('change', syncUpsellImg);
      syncUpsellImg();
    }

    /* ---------- link "Tabela rozmiarów" ---------- */
    root.querySelectorAll('[data-pz-size-chart-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        var chart = root.querySelector('[data-pz-size-chart]');
        if (chart) {
          chart.setAttribute('open', '');
          chart.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    /* ---------- ilość ---------- */
    root.querySelectorAll('[data-pz-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-pz-qty-btn'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
      });
    });

    /* ---------- dodanie do koszyka ---------- */
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var v = currentVariant();
        if (!v || !v.available) return;
        var items = [{ id: v.id, quantity: parseInt(qtyInput.value, 10) || 1 }];

        var upsellCheck = root.querySelector('[data-pz-upsell-check]');
        var upsellVariant = root.querySelector('[data-pz-upsell-variant]');
        if (upsellCheck && upsellCheck.checked && upsellVariant && upsellVariant.value) {
          items.push({ id: parseInt(upsellVariant.value, 10), quantity: 1 });
        }

        atcBtn.disabled = true;
        if (atcLabel) atcLabel.textContent = atcBtn.getAttribute('data-label-adding');
        if (errEl) errEl.style.display = 'none';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Błąd'); }); return r.json(); })
          .then(function () {
            if (document.querySelector('[data-pz-cart]')) {
              // koszyk pieszo (drawer) — otwórz zamiast przekierowania
              atcBtn.disabled = false;
              if (atcLabel) atcLabel.textContent = atcBtn.getAttribute('data-label-add');
              document.dispatchEvent(new CustomEvent('pieszo:cart:open'));
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            atcBtn.disabled = false;
            if (atcLabel) atcLabel.textContent = atcBtn.getAttribute('data-label-add');
            if (errEl) { errEl.textContent = err.message; errEl.style.display = 'block'; }
          });
      });
    }

    render(false);
    syncGallery(0);
  }

  function init() {
    document.querySelectorAll('[data-pz-hero]').forEach(initHero);

    // przyciski CTA w niższych sekcjach — płynny scroll do buy boxa
    document.querySelectorAll('[data-pz-scroll-top]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var hero = document.querySelector('[data-pz-hero]');
        if (hero) {
          e.preventDefault();
          hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // wsparcie edytora motywu Shopify (przeładowanie sekcji)
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-pz-hero]');
    if (hero) initHero(hero);
  });
})();
